import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=012a512e&scoped=true&"
import script from "./Lightbox.vue?vue&type=script&lang=ts&"
export * from "./Lightbox.vue?vue&type=script&lang=ts&"
import style0 from "./Lightbox.vue?vue&type=style&index=0&id=012a512e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a512e",
  null
  
)

export default component.exports